import React from 'react';
import { Route } from 'react-router-dom';
import AdminDashboard from '../Admin Pages/LoginComponent';
import JobUpload from '../Admin Pages/JobUpload';
import EditJob from '../Admin Pages/EditJob';
import UploadPlacementNews from '../Admin Pages/UploadPlacementNews';
import EditPlacementNews from '../Admin Pages/EditPlacementNews';
import UploadMonthlyNews from '../Admin Pages/UploadMonthlyNews';
import EditMonthlyNews from '../Admin Pages/EditMonthlyNews';
import DirectorySearch from '../Admin Pages/DirectorySearch';
import JobDirectory from '../Admin Pages/JobDirectory';
import PlacementDirectory from '../Admin Pages/PlacementDirectory';
import MonthlyNewsDirectory from '../Admin Pages/MonthlyNewsDirectory';
import ProtectedRoute from './ProtectedRoute';

export const adminRoutes = [
  <Route key="admin-dashboard" path="/admin-dashboard" element={<AdminDashboard />} />,
  <Route 
    key="job-upload" 
    path="/admin/job-upload" 
    element={
      <ProtectedRoute>
        <JobUpload />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="edit-job" 
    path="/admin/edit-job" 
    element={
      <ProtectedRoute>
        <EditJob />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="upload-placement-news" 
    path="/admin/upload-placement-news" 
    element={
      <ProtectedRoute>
        <UploadPlacementNews />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="edit-placement-news" 
    path="/admin/edit-placement-news" 
    element={
      <ProtectedRoute>
        <EditPlacementNews />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="upload-monthly-news" 
    path="/admin/upload-monthly-news" 
    element={
      <ProtectedRoute>
        <UploadMonthlyNews />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="edit-monthly-news" 
    path="/admin/edit-monthly-news" 
    element={
      <ProtectedRoute>
        <EditMonthlyNews />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="directory-search" 
    path="/admin/directory-search" 
    element={
      <ProtectedRoute>
        <DirectorySearch />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="job-directory" 
    path="/admin/job-directory" 
    element={
      <ProtectedRoute>
        <JobDirectory />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="placement-directory" 
    path="/admin/placement-directory" 
    element={
      <ProtectedRoute>
        <PlacementDirectory />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="monthly-news-directory" 
    path="/admin/monthly-news-directory" 
    element={
      <ProtectedRoute>
        <MonthlyNewsDirectory />
      </ProtectedRoute>
    } 
  />,
];
